import { BlogSection } from "@/types/blog";

export const innererAntreiber: BlogSection = {
  id: "innerer-antreiber",
  title: "Zwischen innerem Antreiber und kluger Selbstführung",
  content: `
    <p>„Ich darf jetzt nicht schwach sein."<br>
    „Andere schaffen das doch auch."<br>
    „Ich verliere den Anschluss."</p>
    
    <p>Diese Gedanken sind keine persönlichen Fehlleistungen, sondern kognitive Verzerrungen aus Leistungs- und Kontrollmustern. Die Stresspsychologie nennt das die Illusion der Kontrolle. Der Glaube, durch Aktivität könne man Unsicherheit bannen. Doch Krankheit entzieht sich dieser Logik: Sie erzwingt Akzeptanz.</p>
    
    <h3>Selbstregulation statt Selbstoptimierung</h3>
    
    <p>Selbstführung heißt, mit dem Körper statt gegen ihn zu arbeiten. Neuropsychologisch besteht Regulation aus drei Schritten:</p>
    
    <ul>
      <li><strong>Wahrnehmen:</strong> Signale erkennen. Müdigkeit, Gereiztheit, Spannung</li>
      <li><strong>Benennen:</strong> Gefühle klar formulieren („Ich bin erschöpft, nicht faul")</li>
      <li><strong>Reagieren:</strong> Mikropausen, Atemrhythmus, Rituale der Selbstberuhigung</li>
    </ul>
    
    <p>Diese Schritte aktivieren den präfrontalen Cortex, der Impulse ordnet und Distanz zum Stressreiz schafft. Und stabilisieren so Vagusaktivität und Immunsystem.</p>
    
    <h3>Drei Zustände des Nervensystems</h3>
    
    <p>Nach der Polyvagal-Theorie reagiert unser Nervensystem in drei Modi:</p>
    
    <ul>
      <li><strong>Mobilisierung (Sympathikus):</strong> Aktivität, Kampf, Flucht</li>
      <li><strong>Soziale Verbundenheit (ventraler Vagus):</strong> Sicherheit, Offenheit</li>
      <li><strong>Abschaltung (dorsaler Vagus):</strong> Rückzug, Erschöpfung</li>
    </ul>
    
    <p>Ein Infekt ist oft eine natürliche Verschiebung Richtung Abschaltung. Das System fährt runter, um Heilung zu ermöglichen. Selbstführung bedeutet dann nicht, „wieder hochzufahren", sondern diese Phase bewusst zu halten, bis Regulation von selbst zurückkehrt.</p>
    
    <p>Mit der Resilienzkurve verbunden: Nach jedem Leistungshoch folgt eine notwendige Regenerationsphase. Wer sie akzeptiert, erreicht langfristig Stabilität. Wer sie überspringt, stürzt ab.</p>
  `
};
